// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"691":"component---src-pages-index-tsx","883":"component---src-pages-404-js"}[chunkId] + "-" + {"691":"279520db1a12399b8319","883":"8e08e21836fb49ae3ca2"}[chunkId] + ".js";
};